import * as React from "react";
import { cn } from "../lib/utils";

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options?: SelectOption[];
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ options, children, className, ...props }, ref) => {
    return (
      <div className="relative inline-flex items-center">
        <select
          ref={ref}
          {...props}
          className={cn(
            "h-[34px] pl-2.5 pr-7 rounded-base border border-border-strong bg-surface text-xs text-ink-muted cursor-pointer appearance-none outline-none focus:border-primary",
            className,
          )}
        >
          {options
            ? options.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))
            : children}
        </select>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="absolute right-1.5 pointer-events-none text-ink-subtle"
        >
          <polyline points="6,9 12,15 18,9" />
        </svg>
      </div>
    );
  },
);
Select.displayName = "Select";
